module.exports = __webpack_public_path__ + "img/instagram-brands.503aeb23.svg";